import { SurveyForm } from "./SurveyForm";

import { BooleanField, StringField } from "@/core/fields";

export class EquilibriumSurveyForm extends SurveyForm {
  public question1 = false;
  public question2 = false;
  public question3 = false;
  public question4 = false;
  public question5 = false;
  public question6 = false;
  public question7 = false;
  public question8 = false;
  public question9 = false;
  public question10 = false;
  public question10Details: string | undefined = undefined;
  public question11 = false;
  public question12 = false;
  public question13 = false;
  public question14 = false;
  public question14Details: string | undefined = undefined;
  public question15 = false;
  public question16 = false;
  public question17 = false;
  public question18 = false;
  public question19 = false;
  public question20: string | undefined = "Normale funzione dell'equilibrio";

  public constructor(firestoreData?: Record<string, unknown>) {
    super(firestoreData);
    if (firestoreData !== undefined) this.fromFirestore(firestoreData);

    this.isPrintable = true;
  }

  public fromFirestore(data: Record<string, unknown>): EquilibriumSurveyForm {
    super.fromFirestore(data);

    this.question1 = BooleanField.fromFirestore(data.question1);
    this.question2 = BooleanField.fromFirestore(data.question2);
    this.question3 = BooleanField.fromFirestore(data.question3);
    this.question4 = BooleanField.fromFirestore(data.question4);
    this.question5 = BooleanField.fromFirestore(data.question5);
    this.question6 = BooleanField.fromFirestore(data.question6);
    this.question7 = BooleanField.fromFirestore(data.question7);
    this.question8 = BooleanField.fromFirestore(data.question8);
    this.question9 = BooleanField.fromFirestore(data.question9);
    this.question10 = BooleanField.fromFirestore(data.question10);
    this.question10Details = StringField.fromFirestore(data.question10Details);
    this.question11 = BooleanField.fromFirestore(data.question11);
    this.question12 = BooleanField.fromFirestore(data.question12);
    this.question13 = BooleanField.fromFirestore(data.question13);
    this.question14 = BooleanField.fromFirestore(data.question14);
    this.question14Details = StringField.fromFirestore(data.question14Details);
    this.question15 = BooleanField.fromFirestore(data.question15);
    this.question16 = BooleanField.fromFirestore(data.question16);
    this.question17 = BooleanField.fromFirestore(data.question17);
    this.question18 = BooleanField.fromFirestore(data.question18);
    this.question19 = BooleanField.fromFirestore(data.question19);
    this.question20 = StringField.fromFirestore(data.question20);

    return this;
  }

  public toFirestore(): Record<string, unknown> {
    const firestoreData: Record<string, unknown> = super.toFirestore();

    firestoreData.question1 = BooleanField.toFirestore(this.question1);
    firestoreData.question2 = BooleanField.toFirestore(this.question2);
    firestoreData.question3 = BooleanField.toFirestore(this.question3);
    firestoreData.question4 = BooleanField.toFirestore(this.question4);
    firestoreData.question5 = BooleanField.toFirestore(this.question5);
    firestoreData.question6 = BooleanField.toFirestore(this.question6);
    firestoreData.question7 = BooleanField.toFirestore(this.question7);
    firestoreData.question8 = BooleanField.toFirestore(this.question8);
    firestoreData.question9 = BooleanField.toFirestore(this.question9);
    firestoreData.question10 = BooleanField.toFirestore(this.question10);
    firestoreData.question10Details = StringField.toFirestore(this.question10Details);
    firestoreData.question11 = BooleanField.toFirestore(this.question11);
    firestoreData.question12 = BooleanField.toFirestore(this.question12);
    firestoreData.question13 = BooleanField.toFirestore(this.question13);
    firestoreData.question14 = BooleanField.toFirestore(this.question14);
    firestoreData.question14Details = StringField.toFirestore(this.question14Details);
    firestoreData.question15 = BooleanField.toFirestore(this.question15);
    firestoreData.question16 = BooleanField.toFirestore(this.question16);
    firestoreData.question17 = BooleanField.toFirestore(this.question17);
    firestoreData.question18 = BooleanField.toFirestore(this.question18);
    firestoreData.question19 = BooleanField.toFirestore(this.question19);
    firestoreData.question20 = StringField.toFirestore(this.question20);

    return firestoreData;
  }

  public fromOfflineCache(data: Record<string, unknown>): EquilibriumSurveyForm {
    super.fromOfflineCache(data);

    this.question1 = BooleanField.fromOfflineCache(data.question1);
    this.question2 = BooleanField.fromOfflineCache(data.question2);
    this.question3 = BooleanField.fromOfflineCache(data.question3);
    this.question4 = BooleanField.fromOfflineCache(data.question4);
    this.question5 = BooleanField.fromOfflineCache(data.question5);
    this.question6 = BooleanField.fromOfflineCache(data.question6);
    this.question7 = BooleanField.fromOfflineCache(data.question7);
    this.question8 = BooleanField.fromOfflineCache(data.question8);
    this.question9 = BooleanField.fromOfflineCache(data.question9);
    this.question10 = BooleanField.fromOfflineCache(data.question10);
    this.question10Details = StringField.fromOfflineCache(data.question10Details);
    this.question11 = BooleanField.fromOfflineCache(data.question11);
    this.question12 = BooleanField.fromOfflineCache(data.question12);
    this.question13 = BooleanField.fromOfflineCache(data.question13);
    this.question14 = BooleanField.fromOfflineCache(data.question14);
    this.question14Details = StringField.fromOfflineCache(data.question14Details);
    this.question15 = BooleanField.fromOfflineCache(data.question15);
    this.question16 = BooleanField.fromOfflineCache(data.question16);
    this.question17 = BooleanField.fromOfflineCache(data.question17);
    this.question18 = BooleanField.fromOfflineCache(data.question18);
    this.question19 = BooleanField.fromOfflineCache(data.question19);
    this.question20 = StringField.fromOfflineCache(data.question20);

    return this;
  }

  public toOfflineCache(): Record<string, unknown> {
    const firestoreData: Record<string, unknown> = super.toOfflineCache();

    firestoreData.question1 = BooleanField.toOfflineCache(this.question1);
    firestoreData.question2 = BooleanField.toOfflineCache(this.question2);
    firestoreData.question3 = BooleanField.toOfflineCache(this.question3);
    firestoreData.question4 = BooleanField.toOfflineCache(this.question4);
    firestoreData.question5 = BooleanField.toOfflineCache(this.question5);
    firestoreData.question6 = BooleanField.toOfflineCache(this.question6);
    firestoreData.question7 = BooleanField.toOfflineCache(this.question7);
    firestoreData.question8 = BooleanField.toOfflineCache(this.question8);
    firestoreData.question9 = BooleanField.toOfflineCache(this.question9);
    firestoreData.question10 = BooleanField.toOfflineCache(this.question10);
    firestoreData.question10Details = StringField.toOfflineCache(this.question10Details);
    firestoreData.question11 = BooleanField.toOfflineCache(this.question11);
    firestoreData.question12 = BooleanField.toOfflineCache(this.question12);
    firestoreData.question13 = BooleanField.toOfflineCache(this.question13);
    firestoreData.question14 = BooleanField.toOfflineCache(this.question14);
    firestoreData.question14Details = StringField.toOfflineCache(this.question14Details);
    firestoreData.question15 = BooleanField.toOfflineCache(this.question15);
    firestoreData.question16 = BooleanField.toOfflineCache(this.question16);
    firestoreData.question17 = BooleanField.toOfflineCache(this.question17);
    firestoreData.question18 = BooleanField.toOfflineCache(this.question18);
    firestoreData.question19 = BooleanField.toOfflineCache(this.question19);
    firestoreData.question20 = StringField.toOfflineCache(this.question20);

    return firestoreData;
  }
}
